export default __webpack_public_path__ + "static/media/sketch-international-header.83346c60.png";